<template>

    <div class="spinner"/>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Spinner'
    })

</script>

<style lang="scss">

    @include component(spinner) {

        width: 24px;
        height: 24px;
        border: 4px white solid;
        border-top: 4px #4285EB solid;
        border-radius: 50%;
        animation: rotation .8s linear infinite;

        @keyframes rotation {

            from {

                transform: rotate(0deg);

            }

            to {

                transform: rotate(360deg);

            }

        }

    }

</style>
